export * from './lib/shared-ui-lightbox.module';
export * from './lib/lightbox/lightbox.component';
